<template>
  <div>
    <p class="cm-mg-p-wzd">
      {{ $t('config.profile_permits_info') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-6">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('common_words.profile') }} *</label
          >
          <br />
          <el-select
            clearable
            filterable
            class="select-primary custom-width-select required-second-step shadow-sm"
            size="large"
            v-model="model.role_id"
            :placeholder="`${$t('common_words.select')}...`"
            @change="runTreePermissions()"
          >
            <el-option
              v-for="option in roles"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.name"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <br />
    <label>{{ $t('common_words.permissions') }}</label>
    <hr />
    <div class="row">
      <div class="col-5">
        <blockquote>
          <h5>{{ $t('common_words.globals') }}</h5>
          <p>
            {{ $t('config.select_global_permits') }}
          </p>
          <el-tree
            :data="general_permissions"
            show-checkbox
            node-key="id"
            :default-expanded-keys="[0]"
            :default-checked-keys="model.general_permissions"
            :props="defaultProps"
            @check="handleGeneralPermissions"
            ref="general"
          >
          </el-tree>
        </blockquote>
      </div>
      <div class="col-7">
        <blockquote>
          <h5>{{ $t('common_words.specifics') }}</h5>
          <p>
            {{ $t('config.select_specific_permits') }}
          </p>
          <el-tree
            :data="specific_permissions"
            show-checkbox
            node-key="id"
            :default-expanded-keys="[0]"
            :default-checked-keys="model.specific_permissions"
            :props="defaultProps"
            @check="handleSpecificPermissions"
            ref="specific"
          >
          </el-tree>
        </blockquote>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store';
import { mapActions } from 'vuex';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinMasters from 'src/util/mixinMasters';
import { Tree } from 'element-ui';
import { Axios } from 'src/class/Axios.js';
import { assembleTreePermission } from 'src/util/Util';

export default {
  components: {
    [Tree.name]: Tree,
  },

  data() {
    return {
      general_permissions: [],
      specific_permissions: [],
      specific_permissions_initial: [],
      model: {
        role_id: '',
        general_permissions: [],
        specific_permissions: [],
        selected_general_permissions: [],
        selected_specific_permissions: [],
      },
      roles: [],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
    };
  },

  mixins: [MixinPermissions, MixinMasters],

  methods: {
    ...mapActions({
      buildPermissionsForTree: 'utils/buildPermissionsForTree',
    }),

    runTreePermissions() {
      const selected_role = this.roles.filter(
        (role) => role.id === parseInt(this.model.role_id)
      );
      let modules = selected_role[0]
        ? selected_role[0].modules.map((module) => module.id)
        : [];
      this.specific_permissions = assembleTreePermission(
        modules,
        this.specific_permissions_initial
      );
    },

    resetTree() {
      this.$refs.specific.setCheckedKeys(this.model.specific_permissions);
      this.$refs.general.setCheckedKeys(this.model.general_permissions);
    },

    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    handleGeneralPermissions(data, checked) {
      this.model.general_permissions = checked.checkedKeys;
      this.model.selected_general_permissions = [];
      checked.checkedNodes.forEach((element) => {
        if (!element.children) {
          this.model.selected_general_permissions.push(element);
        }
      });
    },

    handleSpecificPermissions(data, checked) {
      this.model.specific_permissions = checked.checkedKeys;
      this.model.selected_specific_permissions = [];
      checked.checkedNodes.forEach((element) => {
        if (!element.children) {
          this.model.selected_specific_permissions.push(element);
        }
      });
    },

    validate() {
      return this.buildPermissionsForTree(
        this.model.selected_specific_permissions
      )
        .then((response) => {
          let othersR;
          this.roles.forEach((item) => {
            if (this.model.role_id == item.id) {
              othersR = item.name;
            }
          });

          let general = JSON.parse(
            JSON.stringify(this.model.selected_general_permissions)
          );
          this.$emit('fillUserForm', 'secondStep', {
            selected_general_permissions: general.map((item) => {
              item.disabled = true;
              return item;
            }),
            selected_specific_permissions:
              this.buildDefaultArrayForTree(response),
            name_role: othersR,
          });
        })
        .then((resp) => {
          return store
            .dispatch('utils/validationInputsRequired', '-second-step')
            .then(() => {
              return true;
            });
        });
    },
  },

  mounted() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);

      let editForm = undefined;
      if (this.isUpdate() && sessionStorage.getItem('editForm')) {
        editForm = JSON.parse(sessionStorage.getItem('editForm'));
      }

      Promise.all([
        Axios.getMasters('roles/indexfield'),
        Axios.getMasters('permissions/treepermissions'),
      ])
        .then((response) => {
          const [response_roles, response_permissions] = response;
          this.roles = response_roles.data.data;

          try {
            this.general_permissions =
              response_permissions.data.general[0] &&
              response_permissions.data.general[0].children.length === 0
                ? []
                : response_permissions.data.general;
          } catch (error) {
            console.log(error);
            this.general_permissions = [];
          }

          try {
            this.specific_permissions =
              response_permissions.data.specific[0] &&
              response_permissions.data.specific[0].children.length === 0
                ? []
                : response_permissions.data.specific;
          } catch (error) {
            console.log(error);
            this.specific_permissions = [];
          }

          this.specific_permissions_initial = JSON.parse(
            JSON.stringify(this.specific_permissions)
          );

          if (!sessionStorage.getItem('editForm') && this.roles.length == 1)
            this.model.role_id = this.roles[0].id;

          if (editForm) {
            this.model.role_id = editForm.role_id;
            this.model.general_permissions = editForm.general_permissions;
            this.model.selected_general_permissions =
              editForm.selected_general_permissions;

            this.model.specific_permissions = editForm.specific_permissions;
            this.model.selected_specific_permissions =
              editForm.selected_specific_permissions;

            let sn = false;
            this.roles.forEach((element) => {
              if (element.id == editForm.role_id) {
                sn = true;
                return;
              }
            });

            if (!sn) this.model.role_id = '';

            this.runTreePermissions();
          }

          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
};
</script>
<style></style>
